import { Skeleton, SkeletonCard, SkeletonRow } from '@/components/ui';
import { useI18n } from '@/lib/i18n';

interface RouteLoadingFallbackProps {
  fullScreen?: boolean;
}

/**
 * Keeps the loading state visually consistent with the page shell while a
 * lazy route chunk is fetched. The outer fallback uses fullScreen only as a
 * defensive fallback for routes outside an application shell.
 */
export function RouteLoadingFallback({ fullScreen = false }: RouteLoadingFallbackProps) {
  const { t } = useI18n();
  return (
    <div
      className={fullScreen ? 'min-h-screen bg-surface-page p-4 sm:p-6' : 'space-y-6'}
      role="status"
      aria-live="polite"
    >
      <span className="sr-only">{t('tp.layout.loadingPage')}</span>
      <div className="space-y-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-80 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
      <div className="overflow-hidden rounded-md border border-line bg-white">
        <SkeletonRow rows={5} />
      </div>
    </div>
  );
}
